import { Component, OnInit } from '@angular/core';
import { HomeService } from '../_services/home.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Title } from '@angular/platform-browser';
import { AuthenticationService } from '../_services/index';
import { GoogleAnalyticsService } from '../_services/google-analytics.service';
@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss']
})

export class SearchResultComponent implements OnInit {
  searchdata: any[];
  selectedValue: string;
  inputValue: any;
  p: number = 1;
  collection: any[] = [];
  count: number = 0;
  text: string;
  itemsPerPage: number = 0;
  currentPage: number = 1;
  totalItems: number;
  searchKeyword: any;
  keyword = 'name';
  data = [];
  searchBanner: any;
  searchTextboxNote: any;
  searchTextboxHover: any;
  searchButtonHover: any;
  hideKbSearch: boolean= false;
  excludeArticleId: any[]=[];
  i18n : any;
  config = {
    itemsPerPage: 0,
    currentPage: 0,
    totalItems: 0
  };
  entireCollection: any[]=[];
  searchResultsFound: boolean;
  caseAlertMessage: string;
  alert: boolean=false;
  delayed: boolean = false ;
  isLoading: boolean = true;

  constructor(private homeService: HomeService,
    private spinner: NgxSpinnerService,
    private authenticationService: AuthenticationService,
    private gaService : GoogleAnalyticsService,
    private activatedRoute: ActivatedRoute, private router: Router) {
      this.activatedRoute.queryParams.subscribe(params => {
        this.router.routeReuseStrategy.shouldReuseRoute = function(){return false;};
        console.log("GOT IT:", params);
        this.currentPage = params['currentPage'] === 0 ? 1 : params['currentPage'] ;
        this.config.currentPage = this.currentPage;
        this.selectedValue = params['selectedValue'];
        if(params['currentPage'] !== 0){
          this.searchKeyword = this.selectedValue;
        }
        this.search(this.selectedValue);
        this.i18n = this.homeService.session.get('i18n');
      });
  }

  ngOnInit() {
    this.gaService.updatePageName();
    this.homeService.getKbSearchConfiguration().subscribe(res => {
      if (res.return_body !== null) {
        this.searchBanner = res.return_body.searchBanner;
        this.searchTextboxNote = res.return_body.searchTextboxNote;
        this.searchTextboxHover = res.return_body.searchTextboxHoverNote;
        this.searchButtonHover = res.return_body.searchButtonHoverNote;
        for( var excludeId of res.return_body.excludeArticleIds.split(',') ){
          this.excludeArticleId.push(excludeId.split('-')[1]);
        }
      }
    });
  }

  selectEvent(item) {
    this.selectedValue = item.name;
    this.search(this.selectedValue);
  }

  onChangeSearch(val: string) {
    this.selectedValue = val;
    this.data = [];
    if (val != '') {
      this.homeService.getSearchData(val).subscribe(res => {
        this.data = [];
        res.return_body.map((response, index) => {
          this.data.push({ id: index, name: response });
        })
      });
    }
  }

  onFocused(e) {
    this.data = [];
  }

  viewArticle(id) {
    // this.homeService.setArticleViewDetails = item;  
    this.router.navigate(['/' + this.router.url.split('/')[1] + '/viewarticles'], { queryParams: { articleId: id , currentPage: this.config.currentPage, selectedValue: this.selectedValue} });
  }

  search(selectedValue) {
    this.homeService.sendMessage(true);
    let articleCount = 0;
    if (this.searchKeyword !== this.selectedValue) {
       this.searchKeyword = this.selectedValue;
       this.currentPage = 1;
    }
    if(selectedValue != '' && selectedValue){
      console.log("current page ", this.currentPage);
      this.selectedValue = selectedValue;
      this.inputValue = { "inputText": this.selectedValue, "count": 5000, "hightlighter": true }
      this.homeService.getSearchResults(this.itemsPerPage, this.currentPage,this.inputValue).subscribe(res => {
        this.searchResultsFound = true;
        var articleResult: any = res.return_body;
        if (articleResult === null || articleResult.articles === null) {
          this.collection = [];
          this.count = 0;
          this.text = this.selectedValue;
          this.config = {
            itemsPerPage: 0,
            currentPage: 0,
            totalItems: 0
          };
        } else {
          this.collection = articleResult.articles;
          for(let collection of this.collection){
              if(this.excludeArticleId.includes(collection.id)){
                articleCount = articleCount+1;
              }
              else{
                this.entireCollection.push(collection);
              }
          }
          this.count = articleResult.article_count-articleCount;
          this.text = articleResult.suggest_text;
          this.config = {
            itemsPerPage: articleResult.page_size+articleCount,
            currentPage: this.currentPage,
            totalItems: articleResult.article_count
          };
        }
        this.isLoading = false;
        this.homeService.sendMessage(false);
      }, (err) => {
        this.isLoading = false;
        this.searchResultsFound = false;
        this.homeService.sendMessage(false);
      });
    }else{
      this.isLoading = false;
      this.homeService.sendMessage(false);
      this.collection = [];
      this.count = 0;
      this.text = this.selectedValue;
      this.config = {
        itemsPerPage: 0,
        currentPage: 0,
        totalItems: 0
      };
    }
  }

  pageChanged(event) {
    this.currentPage = event;
    this.config.currentPage = event;
    //this.search(this.selectedValue);
  }

  onKeyEnterSearch(event: any, searchkeyWrd: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function(){return false;};
    this.router.navigate(['/' + this.router.url.split('/')[1] + '/searchresults'], { queryParams: { selectedValue: searchkeyWrd, currentPage: 0 }});
  }

  onSearchBtnClicked(searchkeyWrd: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function(){return false;};
    this.router.navigate(['/' + this.router.url.split('/')[1] + '/searchresults'], { queryParams: { selectedValue: searchkeyWrd, currentPage: 0 }});
  }

  handleNavigation(pathValue) {
    if(pathValue){
        this.router.navigate([this.router.url.split("/")[1],pathValue]);  
    }
}

  searchCleared(){
    this.selectedValue = '';
  }

  ngAfterViewInit() {
    this.caseMessage();
  }
  caseMessage(){
      this.caseAlertMessage= sessionStorage.getItem('alertMessage')
      if(this.caseAlertMessage){
        this.alert=true
      }
      setInterval(() => {
       this.delayed=true
       this.alert=false
       sessionStorage.removeItem('alertMessage')
      }, 5000);
    }
  
}
